import { useEffect, useState } from "react";
import type { ReactNode } from "react";

const Delay = ({
  time,
  beforeDelay,
  afterDelay,
}: {
  time: number;
  beforeDelay: ReactNode;
  afterDelay: ReactNode;
}) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setShow(true), time);

    return () => clearTimeout(timer);
  }, [time]);

  return show ? afterDelay : beforeDelay;
};

export default Delay;
